export const MAP_TEST1 = "MAP_TEST1";